import { ENV } from '../config';
import { ALGOLIA_TYPES, STORES } from '../../../gatsby/constants';

type AlgoliaKeys = keyof typeof ALGOLIA_TYPES;
type IndexName = `${typeof env}_${typeof store}_${AlgoliaKeys}`;

const GATSBY_STORE_DELIMITER = '-';
const store = process.env.GATSBY_STORE ? process.env.GATSBY_STORE.split(GATSBY_STORE_DELIMITER)[0] as keyof typeof STORES : 'drukwerkdeal';
const env = process.env.GATSBY_ACTIVE_ENV === 'production' ? 'prod' : 'dev';

export const ENV_TO_INDEX_MAP = {
  staging: 'dev_',
  prod: 'prod_',
};

export const validateIndices = (indices: string[]) => indices
  .join()
  .match(ENV_TO_INDEX_MAP[ENV]) !== null;

export const INDICES = Object.entries(ALGOLIA_TYPES).reduce(
  (indices, [indexName, indexValue]) => ({ ...indices, [indexName]: `${env}_${store}_${indexValue}` }),
  {} as Record<keyof typeof ALGOLIA_TYPES, IndexName>,
);
